// extracted by mini-css-extract-plugin
module.exports = {"case":"UseCases-module--case--97LnD","caseSeparator":"UseCases-module--case-separator--1psNO"};